import {NgModule} from "@angular/core";
import {MaskedInputDirective } from './masked.input.directive';

@NgModule({
	declarations: [MaskedInputDirective],
	exports: [MaskedInputDirective],
})
export class MaskedInputModule {}
